// City Staff Portal — API helpers (Prompt 7).
import { api, API } from "./api";

export async function getCityDashboard(userId, { period, neighborhood } = {}) {
  const params = { user_id: userId };
  if (period) params.period = period;
  if (neighborhood) params.neighborhood = neighborhood;
  const { data } = await api.get("/city-portal/dashboard", { params });
  return data;
}

export async function getHeatmap(userId, { style, typology, scope } = {}) {
  const params = { user_id: userId };
  if (style) params.style = style;
  if (typology) params.typology = typology;
  if (scope) params.scope = scope;
  const { data } = await api.get("/city-portal/heatmap", { params });
  return data;
}

export async function listReviews(userId, { status, q } = {}) {
  const params = { user_id: userId };
  if (status && status !== "all") params.status = status;
  if (q) params.q = q;
  const { data } = await api.get("/city-portal/reviews", { params });
  return data;
}

export async function getReview(designId, userId) {
  const { data } = await api.get(
    `/city-portal/reviews/${encodeURIComponent(designId)}`,
    { params: { user_id: userId } },
  );
  return data;
}

export async function listCases(userId, { status, q } = {}) {
  const params = { user_id: userId };
  if (status && status !== "all") params.status = status;
  if (q) params.q = q;
  const { data } = await api.get("/city-portal/cases", { params });
  return data;
}

export async function getCase(caseId, userId) {
  const { data } = await api.get(
    `/city-portal/cases/${encodeURIComponent(caseId)}`,
    { params: { user_id: userId } },
  );
  return data;
}

export async function syncCase(caseId, userId) {
  const { data } = await api.post(
    `/city-portal/cases/${encodeURIComponent(caseId)}/sync`,
    { actor_user_id: userId },
  );
  return data;
}

export async function getCityProject(projectId, userId) {
  const { data } = await api.get(
    `/city-portal/projects/${encodeURIComponent(projectId)}`,
    { params: { user_id: userId } },
  );
  return data;
}

export async function getAudit(userId, filters = {}) {
  const params = { user_id: userId };
  if (filters.types?.length) params.types = filters.types.join(",");
  if (filters.actor && filters.actor !== "all") params.actor = filters.actor;
  if (filters.neighborhood && filters.neighborhood !== "all")
    params.neighborhood = filters.neighborhood;
  if (filters.from) params.from = filters.from;
  if (filters.to) params.to = filters.to;
  const { data } = await api.get("/city-portal/audit", { params });
  return data;
}

export function exportUrl(kind, userId, extraParams = {}) {
  const usp = new URLSearchParams({ user_id: userId, ...extraParams });
  return `${API}/city-portal/exports/${kind}.csv?${usp.toString()}`;
}

// City Reports — observational. No decisions are written from these calls.
export async function listCityReports(userId) {
  const { data } = await api.get("/city-portal/reports", {
    params: { user_id: userId },
  });
  return data;
}

export function reportCsvUrl(reportId, userId) {
  return `${API}/city-portal/reports/${encodeURIComponent(reportId)}.csv?user_id=${encodeURIComponent(userId)}`;
}

export function reportPdfUrl(reportId, userId) {
  return `${API}/city-portal/reports/${encodeURIComponent(reportId)}.pdf?user_id=${encodeURIComponent(userId)}`;
}

export function reviewDecisionPdfUrl(designId, userId) {
  return `${API}/city-portal/reviews/${encodeURIComponent(designId)}/decision/pdf?user_id=${encodeURIComponent(userId)}`;
}

export async function downloadReviewDecisionPdf(designId, userId, filename) {
  const url = reviewDecisionPdfUrl(designId, userId);
  const res = await fetch(url, { credentials: "omit" });
  if (!res.ok) throw new Error(`Download failed (${res.status})`);
  const blob = await res.blob();
  const objectUrl = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = objectUrl;
  a.download = filename || `design-review-${designId}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
}
